import type {
  AnalyticsProduct,
  FeedbackProduct,
} from '@hotjar/webapp/domains/common/product/types';
import { ProductType } from '@hotjar/webapp/domains/common/product/types';
import { getFreeTierProducts } from '../utils';

import { useProductCatalog } from './useProductCatalog';

interface Props {
  [ProductType.Analytics]: AnalyticsProduct | null;
  [ProductType.Feedback]: FeedbackProduct | null;
}

/**
 * This hook will return the free analytics and feedback products from the
 * product catalog hook.
 */
export const useGetFreeTierProducts = (): Props => {
  const { data: productCatalog } = useProductCatalog();

  const freeProducts = getFreeTierProducts(productCatalog);

  return {
    [ProductType.Analytics]:
      (freeProducts?.find(
        (product) => product.type === ProductType.Analytics,
      ) as AnalyticsProduct) || null,
    [ProductType.Feedback]:
      (freeProducts?.find((product) => product.type === ProductType.Feedback) as FeedbackProduct) ||
      null,
  };
};
